import { ReactNode } from 'react';
import { useFormTableErrors } from './TanstackFormTable';
import styled from 'styled-components';
import { colorError } from '@atlas-frontend/design-tokens';

interface ErrorRowIndicatorCellProps {
  rowIndex: number;
  children: ReactNode;
}

export const ErrorRowIndicatorCell: React.FC<ErrorRowIndicatorCellProps> = ({
  rowIndex,
  children,
}) => {
  const errorInfo = useFormTableErrors();
  const hasError = errorInfo?.rowIndicesWithErrors.has(rowIndex) || false;

  return <ErrorRowWrapper $hasError={hasError}>{children}</ErrorRowWrapper>;
};

export const ErrorRowWrapper = styled.div<{ $hasError: boolean }>`
  width: 100%;
  height: 100%;
  ${({ $hasError }) =>
    $hasError &&
    `
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: -6px;
      top: -4px;
      bottom: -4px;
      width: 3px;
      background-color: ${colorError};
    }
  `}
`;
